import styled, { css } from 'styled-components'

import type { TextareaProps } from './types'

export const TextareaWrapper = styled.div<
    Pick<TextareaProps, 'bordered' | 'highlightable' | 'focusOutLineColor' | 'enableBackgroundColor'>
>`
    display: flex;
    border: 1px solid transparent;
    ${props =>
        props.bordered &&
        css`
            border: 1px solid var(--color-gray-200);
            border-radius: 6px;
        `};

    ${({ highlightable = true, enableBackgroundColor }) => {
        return (
            highlightable &&
            enableBackgroundColor &&
            css`
                background-color: var(--color-gray-50);
            `
        )
    }}
    &:focus-within {
        ${({ highlightable = true, focusOutLineColor, bordered, enableBackgroundColor }) => {
            const borderColor = focusOutLineColor ?? (bordered ? 'var(--color-gray-200)' : 'transparent')
            return (
                highlightable &&
                enableBackgroundColor &&
                css`
                    background-color: #fff;
                    border: 1px solid ${borderColor};
                    border-radius: 6px;
                `
            )
        }}
    }

    transition: background 0.2s ease;
`

export const TextareaContent = styled.textarea<
    TextareaProps & { bordered?: boolean; textSize: TextareaProps['textSize']; textAlign: TextareaProps['textAlign'] }
>`
    width: 100%;
    border: none;
    min-height: 25px;
    max-height: 200px;
    outline: none;
    background-color: transparent;
    padding: ${({ bordered }) => (bordered ? '2px 4px' : '4px 4px 4px 5px')};
    font-size: ${({ textSize }) => textSize};
    line-height: 25px;
    text-align: ${({ textAlign }) => textAlign};
    color: var(--color-black);
    resize: none;
    overflow-x: hidden;
    overflow-y: auto;

    ::placeholder {
        font-weight: var(--font-weight-normal);
        color: var(--color-gray-300);
    }
`
